import { useCookies } from 'vue3-cookies';
const { cookies } = useCookies();

export default {
  getStore(state) {
    if (state.storeList.length > 0) {
      return state.storeList.slice(0, 20);
    } else {
      return state.storeList;
    }
    // return JSON.parse(localStorage.getItem('store'));
    // return JSON.parse(cookies.get('store') || '[]');
  },
  getProduct(state) {
    return state.productList.slice(0, 20);
    // return JSON.parse(cookies.get('product') || '[]');
  },
  getAddress() {
    return JSON.parse(cookies.get('address') || '[]');
  },

  getRecentStoreInfo(state) {
    return state.storeInfo;
  }
};
